/* CXNSISTENTLY — global behaviour
   Vanilla JS, no framework. Keep this file small; it blocks nothing. */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     Mobile menu
     ---------------------------------------------------------------------- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.getElementById('HeaderDrawer');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function () {
      var open = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (drawer.getAttribute('data-open') !== 'true') return;
      drawer.setAttribute('data-open', 'false');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    });
  }

  /* ----------------------------------------------------------------------
     Accordions — product detail disclosures
     ---------------------------------------------------------------------- */
  function initAccordions() {
    var triggers = document.querySelectorAll('[data-accordion-trigger]');

    Array.prototype.forEach.call(triggers, function (trigger) {
      if (trigger.dataset.bound === 'true') return;
      trigger.dataset.bound = 'true';

      trigger.addEventListener('click', function () {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  }

  /* ----------------------------------------------------------------------
     Carousel — arrows drive a native scroll-snap track.
     Touch swipe and trackpad scroll work without any of this.
     ---------------------------------------------------------------------- */
  function initCarousels() {
    var carousels = document.querySelectorAll('[data-carousel]');

    Array.prototype.forEach.call(carousels, function (carousel) {
      // The theme editor re-fires shopify:section:load on every setting change.
      // Without this guard, arrow listeners stack and one click scrolls twice.
      if (carousel.dataset.bound === 'true') return;
      carousel.dataset.bound = 'true';

      var track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;

      var section = carousel.closest('.shopify-section') || carousel.parentNode;
      var prevButtons = section.querySelectorAll('[data-carousel-prev]');
      var nextButtons = section.querySelectorAll('[data-carousel-next]');

      function step() {
        var item = track.querySelector('[data-carousel-item]');
        if (!item) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        // 2px tolerance absorbs sub-pixel rounding at the track ends
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

        Array.prototype.forEach.call(prevButtons, function (b) {
          b.disabled = atStart;
        });
        Array.prototype.forEach.call(nextButtons, function (b) {
          b.disabled = atEnd;
        });
      }

      Array.prototype.forEach.call(prevButtons, function (button) {
        button.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      });

      Array.prototype.forEach.call(nextButtons, function (button) {
        button.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      });

      var frame;
      track.addEventListener('scroll', function () {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(updateArrows);
      });

      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  /* ----------------------------------------------------------------------
     Slideshow — cross-fading hero.

     Autoplay is suppressed for prefers-reduced-motion, and pauses on hover,
     on keyboard focus, and when the tab is backgrounded.
     ---------------------------------------------------------------------- */
  function initSlideshows() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var shows = document.querySelectorAll('[data-slideshow]');

    Array.prototype.forEach.call(shows, function (show) {
      if (show.dataset.bound === 'true') return;
      show.dataset.bound = 'true';

      var slides = show.querySelectorAll('[data-slide]');
      if (slides.length < 2) return;

      var dots = show.querySelectorAll('[data-slide-dot]');
      var pauseButton = show.querySelector('[data-slide-pause]');
      var interval = parseInt(show.dataset.interval, 10) || 6000;
      var autoplay = show.dataset.autoplay === 'true' && !reduceMotion;

      var index = 0;
      var timer = null;
      var paused = false;

      function show_(next) {
        index = (next + slides.length) % slides.length;

        Array.prototype.forEach.call(slides, function (slide, i) {
          var active = i === index;
          slide.setAttribute('data-active', String(active));
          if (active) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
          // Keep offscreen links out of the tab order
          var cta = slide.querySelector('[data-slide-cta]');
          if (cta) {
            if (active) {
              cta.removeAttribute('tabindex');
            } else {
              cta.setAttribute('tabindex', '-1');
            }
          }
        });

        Array.prototype.forEach.call(dots, function (dot, i) {
          dot.setAttribute('aria-current', String(i === index));
        });
      }

      function start() {
        if (!autoplay || paused || timer) return;
        timer = window.setInterval(function () {
          show_(index + 1);
        }, interval);
      }

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      var prev = show.querySelector('[data-slide-prev]');
      var next = show.querySelector('[data-slide-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          show_(index - 1);
          stop();
          start();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          show_(index + 1);
          stop();
          start();
        });
      }

      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.addEventListener('click', function () {
          show_(i);
          stop();
          start();
        });
      });

      if (pauseButton) {
        pauseButton.addEventListener('click', function () {
          paused = !paused;
          if (paused) {
            stop();
          } else {
            start();
          }
          pauseButton.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
          var pauseIcon = pauseButton.querySelector('[data-pause-icon]');
          var playIcon = pauseButton.querySelector('[data-play-icon]');
          if (pauseIcon) pauseIcon.hidden = paused;
          if (playIcon) playIcon.hidden = !paused;
        });
      }

      show.addEventListener('mouseenter', stop);
      show.addEventListener('mouseleave', function () {
        if (!paused) start();
      });
      show.addEventListener('focusin', stop);
      show.addEventListener('focusout', function () {
        if (!paused) start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else if (!paused) {
          start();
        }
      });

      show_(0);
      start();
    });
  }

  /* ----------------------------------------------------------------------
     Size finder

     Deterministic recommendation. Foot length maps to a bracket, then
     width and fit preference shift it. Every rule below is auditable —
     a wrong size here costs a return, so nothing is guessed.
     ---------------------------------------------------------------------- */
  /* ----------------------------------------------------------------------
     Product recommendations — fetches the section and swaps it in
     ---------------------------------------------------------------------- */
  function initRecommendations() {
    var block = document.querySelector('[data-recommendations]');
    if (!block || block.dataset.bound === 'true') return;
    block.dataset.bound = 'true';

    fetch(block.dataset.url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        // Only replace the server-rendered fallback if real results came back
        if (fresh && fresh.innerHTML.trim().length) {
          block.innerHTML = fresh.innerHTML;
          initCarousels();
          initCardMedia();
        }
      })
      .catch(function () {
        /* Fallback collection is already on the page — nothing to do */
      });
  }

  function initSizeFinder() {
    var root = document.querySelector('[data-size-finder]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var dataEl = document.querySelector('[data-size-table]');
    if (!dataEl) return;

    var SIZES;
    try {
      SIZES = JSON.parse(dataEl.textContent).sizes;
    } catch (e) {
      return;
    }

    var trigger = document.querySelector('[data-sf-open]');
    var steps = root.querySelectorAll('[data-sf-step]');
    var progress = root.querySelector('[data-sf-progress]');
    var lengthInput = root.querySelector('[data-sf-length]');
    var errorEl = root.querySelector('[data-sf-error]');
    var usualGrid = root.querySelector('[data-sf-usual-grid]');
    var lastFocused = null;

    var state = { route: null, length: null, usual: null, width: null, fit: null };

    var PROGRESS = { '1': 20, '2a': 45, '2b': 45, '3': 70, '4': 90, result: 100 };

    function goTo(name) {
      Array.prototype.forEach.call(steps, function (step) {
        step.setAttribute('data-active', String(step.dataset.sfStep === name));
      });
      if (progress) progress.style.width = (PROGRESS[name] || 0) + '%';
      root.querySelector('.sf__panel').scrollTop = 0;
    }

    function open() {
      lastFocused = document.activeElement;
      root.hidden = false;
      document.body.style.overflow = 'hidden';
      state = { route: null, length: null, usual: null, width: null, fit: null };
      goTo('1');
      root.querySelector('.sf__panel').focus();
    }

    function close() {
      root.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    /* --- recommendation ------------------------------------------------ */

    function bracketFromLength(cm) {
      for (var i = 0; i < SIZES.length; i++) {
        if (cm <= SIZES[i].cm_max) return i;
      }
      return SIZES.length - 1;
    }

    function recommend() {
      var index;
      var reasons = [];

      if (state.route === 'measured') {
        index = bracketFromLength(state.length);
        reasons.push(state.length.toFixed(1) + ' cm');

        // Near the top of a bracket means between sizes — our guidance is size up
        var ceiling = SIZES[index].cm_max;
        if (ceiling < 99 && ceiling - state.length <= 0.3) {
          index += 1;
          reasons.push('between sizes, so we sized up');
        }
      } else {
        for (var i = 0; i < SIZES.length; i++) {
          if (SIZES[i].us === state.usual) index = i;
        }
        if (index === undefined) index = 2;
        reasons.push('usually a US ' + state.usual);
      }

      if (state.width === 'wide') {
        index += 1;
        reasons.push('a wider foot');
      }

      if (state.fit === 'roomy') {
        index += 1;
        reasons.push('a roomier fit');
      } else if (state.fit === 'snug' && state.width !== 'wide') {
        index -= 1;
        reasons.push('a snug fit');
      }

      if (index < 0) index = 0;
      if (index > SIZES.length - 1) index = SIZES.length - 1;

      return { size: SIZES[index], reasons: reasons };
    }

    function showResult() {
      var result = recommend();
      root.querySelector('[data-sf-result-us]').textContent = 'US ' + result.size.us;
      root.querySelector('[data-sf-result-eu]').textContent = 'EU ' + result.size.eu;

      var reason = 'Based on ' + result.reasons.join(', ') + '.';
      if (state.route === 'usual') {
        reason += ' Measuring your foot gives a more reliable answer.';
      }
      root.querySelector('[data-sf-reason]').textContent = reason;

      root.dataset.sfSize = result.size.us;
      goTo('result');
    }

    /* --- wiring -------------------------------------------------------- */

    if (trigger) trigger.addEventListener('click', open);

    Array.prototype.forEach.call(root.querySelectorAll('[data-sf-close]'), function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) close();
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-sf-answer]'), function (button) {
      button.addEventListener('click', function () {
        var key = button.dataset.sfAnswer;
        state[key] = button.dataset.value;

        if (key === 'route') {
          goTo(state.route === 'measured' ? '2a' : '2b');
        } else if (key === 'width') {
          goTo('4');
        } else if (key === 'fit') {
          showResult();
        }
      });
    });

    // Usual-size grid, built from the same table
    if (usualGrid) {
      SIZES.forEach(function (size) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = size.us;
        button.addEventListener('click', function () {
          state.usual = size.us;
          goTo('3');
        });
        usualGrid.appendChild(button);
      });
    }

    var nextButton = root.querySelector('[data-sf-next="2a"]');
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        var value = parseFloat(lengthInput.value);
        if (isNaN(value) || value < 18 || value > 32) {
          errorEl.hidden = false;
          lengthInput.focus();
          return;
        }
        errorEl.hidden = true;
        state.length = value;
        goTo('3');
      });
    }

    var howtoButton = root.querySelector('[data-sf-howto]');
    var howtoPanel = root.querySelector('[data-sf-howto-panel]');
    if (howtoButton && howtoPanel) {
      howtoButton.addEventListener('click', function () {
        howtoPanel.hidden = !howtoPanel.hidden;
      });
    }

    var restart = root.querySelector('[data-sf-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        state = { route: null, length: null, usual: null, width: null, fit: null };
        if (lengthInput) lengthInput.value = '';
        goTo('1');
      });
    }

    // Selects the matching variant on the product form and closes
    var apply = root.querySelector('[data-sf-apply]');
    if (apply) {
      apply.addEventListener('click', function () {
        var size = root.dataset.sfSize;
        var input = document.querySelector('[data-variant-option][data-size="' + size + '"]');
        if (input && !input.disabled) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          close();
          input.parentNode.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          // Recommended size exists but is out of stock
          var reason = root.querySelector('[data-sf-reason]');
          reason.textContent =
            'US ' + size + ' is sold out right now. Join the waitlist and we will tell you when it returns.';
        }
      });
    }
  }

  /* ----------------------------------------------------------------------
     Product card media

     Desktop: horizontal mouse position maps to an image, so sweeping across
     the card flips through the gallery. Touch: a tap advances one image,
     and only navigates once the last image has been seen.
     ---------------------------------------------------------------------- */
  function initCardMedia() {
    var cards = document.querySelectorAll('[data-card-media]');
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    Array.prototype.forEach.call(cards, function (media) {
      if (media.dataset.bound === 'true') return;
      media.dataset.bound = 'true';

      var images = media.querySelectorAll('[data-card-image]');
      var dots = media.querySelectorAll('[data-card-dot]');
      var count = images.length;
      var href = media.dataset.href;
      var index = 0;

      function setIndex(next) {
        if (next === index || next < 0 || next >= count) return;
        index = next;

        Array.prototype.forEach.call(images, function (img, i) {
          var active = i === index;
          img.setAttribute('data-active', String(active));
          if (active) {
            img.removeAttribute('aria-hidden');
          } else {
            img.setAttribute('aria-hidden', 'true');
          }
        });

        Array.prototype.forEach.call(dots, function (dot, i) {
          dot.setAttribute('data-active', String(i === index));
        });
      }

      if (count > 1 && canHover) {
        media.addEventListener('mousemove', function (event) {
          var rect = media.getBoundingClientRect();
          var ratio = (event.clientX - rect.left) / rect.width;
          var next = Math.floor(ratio * count);
          if (next < 0) next = 0;
          if (next > count - 1) next = count - 1;
          setIndex(next);
        });

        media.addEventListener('mouseleave', function () {
          setIndex(0);
        });
      }

      media.addEventListener('click', function () {
        if (!href) return;

        // Pointer devices: the image area behaves as a link
        if (canHover || count < 2) {
          window.location.href = href;
          return;
        }

        // Touch: step through the images, then let the next tap open the product
        if (index < count - 1) {
          setIndex(index + 1);
        } else {
          window.location.href = href;
        }
      });
    });
  }

  /* ----------------------------------------------------------------------
     Announcement bar — rotates messages
     ---------------------------------------------------------------------- */
  function initAnnounce() {
    var bar = document.querySelector('[data-announce]');
    if (!bar || bar.dataset.bound === 'true') return;
    bar.dataset.bound = 'true';

    var items = bar.querySelectorAll('[data-announce-item]');
    if (items.length < 2) return;

    var interval = parseInt(bar.dataset.interval, 10) || 5000;
    var index = 0;
    var timer = null;

    function step() {
      items[index].setAttribute('data-active', 'false');
      index = (index + 1) % items.length;
      items[index].setAttribute('data-active', 'true');
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(step, interval);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    // Pause while hovered or focused so a message can be read
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    start();
  }

  /* ----------------------------------------------------------------------
     Product gallery — thumbnails swap the main image
     ---------------------------------------------------------------------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery || gallery.dataset.bound === 'true') return;
    gallery.dataset.bound = 'true';

    var images = gallery.querySelectorAll('[data-gallery-image]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (images.length < 2 || thumbs.length === 0) return;

    function select(index) {
      Array.prototype.forEach.call(images, function (img, i) {
        var active = i === index;
        img.setAttribute('data-active', String(active));
        if (active) {
          img.removeAttribute('aria-hidden');
        } else {
          img.setAttribute('aria-hidden', 'true');
        }
      });

      Array.prototype.forEach.call(thumbs, function (thumb, i) {
        thumb.setAttribute('aria-current', String(i === index));
      });
    }

    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      thumb.addEventListener('click', function () {
        select(i);
      });
    });

    // Left/right arrows step through the gallery when a thumb has focus
    gallery.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var current = -1;
      Array.prototype.forEach.call(thumbs, function (t, i) {
        if (t.getAttribute('aria-current') === 'true') current = i;
      });
      if (current === -1) return;
      var next = event.key === 'ArrowRight' ? current + 1 : current - 1;
      if (next < 0 || next >= thumbs.length) return;
      select(next);
      thumbs[next].focus();
      event.preventDefault();
    });
  }

  /* ----------------------------------------------------------------------
     Quick add — fetches the product and adds to cart without leaving the page
     ---------------------------------------------------------------------- */
  function initQuickAdd() {
    var modal = document.querySelector('[data-quick-add-modal]');
    // The document-level listener below must only ever bind once
    if (!modal || modal.dataset.bound === 'true') return;
    modal.dataset.bound = 'true';

    var imageEl = modal.querySelector('[data-qa-image]');
    var titleEl = modal.querySelector('[data-qa-title]');
    var priceEl = modal.querySelector('[data-qa-price]');
    var sizesEl = modal.querySelector('[data-qa-sizes]');
    var errorEl = modal.querySelector('[data-qa-error]');
    var addEl = modal.querySelector('[data-qa-add]');
    var detailsEl = modal.querySelector('[data-qa-details]');
    var guideEl = modal.querySelector('[data-qa-guide]');
    var lastFocused = null;
    var selectedVariant = null;

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    function open(handle, url) {
      lastFocused = document.activeElement;
      selectedVariant = null;
      errorEl.hidden = true;
      sizesEl.innerHTML = '';
      titleEl.textContent = '';
      priceEl.textContent = '';
      imageEl.removeAttribute('src');
      detailsEl.href = url;
      guideEl.href = url;
      addEl.disabled = false;
      addEl.textContent = 'Add to bag';

      modal.hidden = false;
      document.body.style.overflow = 'hidden';

      fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (product) {
          titleEl.textContent = product.title;
          priceEl.textContent = money(product.price);

          if (product.featured_image) {
            imageEl.src = product.featured_image;
            imageEl.alt = product.title;
          }

          product.variants.forEach(function (variant) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'qa__size';
            button.textContent = variant.title;
            button.setAttribute('aria-pressed', 'false');
            if (!variant.available) button.disabled = true;

            button.addEventListener('click', function () {
              selectedVariant = variant.id;
              errorEl.hidden = true;
              sizesEl.querySelectorAll('.qa__size').forEach(function (b) {
                b.setAttribute('aria-pressed', 'false');
              });
              button.setAttribute('aria-pressed', 'true');
            });

            sizesEl.appendChild(button);
          });

          // Single-variant products have nothing to choose
          if (product.variants.length === 1) {
            selectedVariant = product.variants[0].id;
            sizesEl.parentNode.querySelector('.qa__sizes-head').hidden = true;
            sizesEl.hidden = true;
          } else {
            sizesEl.parentNode.querySelector('.qa__sizes-head').hidden = false;
            sizesEl.hidden = false;
          }
        })
        .catch(function () {
          // If the fetch fails, send them to the real product page
          window.location.href = url;
        });
    }

    addEl.addEventListener('click', function () {
      if (!selectedVariant) {
        errorEl.hidden = false;
        return;
      }

      addEl.disabled = true;
      addEl.textContent = 'Adding…';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedVariant, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          addEl.textContent = 'Added';
          return refreshCartCount();
        })
        .then(function () {
          window.setTimeout(close, 700);
        })
        .catch(function () {
          addEl.disabled = false;
          addEl.textContent = 'Add to bag';
          errorEl.hidden = false;
          errorEl.textContent = 'Could not add that. Try the product page.';
        });
    });

    modal.querySelectorAll('[data-qa-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });

    // Delegated so cards added later (recommendations) still work
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-add]');
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      open(trigger.dataset.handle, trigger.dataset.url);
    });
  }

  /* ----------------------------------------------------------------------
     Cart count — keeps the header in sync after an add
     ---------------------------------------------------------------------- */
  function refreshCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var nodes = document.querySelectorAll('[data-cart-count]');
        Array.prototype.forEach.call(nodes, function (node) {
          node.textContent = cart.item_count;
        });
        return cart;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initAccordions();
    initCarousels();
    initSlideshows();
    initSizeFinder();
    initCardMedia();
    initRecommendations();
    initAnnounce();
    initGallery();
    initQuickAdd();
  });

  // Shopify theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', function () {
    initCarousels();
    initAccordions();
    initSlideshows();
    initSizeFinder();
    initCardMedia();
    initRecommendations();
    initAnnounce();
    initGallery();
    initQuickAdd();
  });

  window.theme = { refreshCartCount: refreshCartCount };
})();
